<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="entry.unitId"
          v-bind="getObject('unitId')"
          label="Unidade"
          :items="extraData.globalContext.allUnits"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="entry.packagingId"
          v-bind="getObject('packagingId')"
          label="Embalagem de Comercialização"
          :items="extraData.globalContext.allPackagings"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
          clearable
          @click:clear="entry.packagingId = null"
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" class="px-0" v-if="entry.id"> 
        <MultiSelect
          v-model="entry.packagingIds"
          v-bind="getObject('packagingIds')"
          label="Embalagens"
          :items="packagingsList"
          :loadingItems="packagingsListLoading"
          :readOnly="false"
          :key="packagingsListKey"
        >
           <template v-slot:new_action>
            <PackagingNew
              :inlineAddButton="true"
              @entry-created="packagingCreated"
            />
          </template>
        </MultiSelect>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-switch 
          v-model="entry.forage" 
          inset 
          :label="entry.forage ? 'É forageira' : 'Não é forageira'"
          @change="changeForage"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>    

      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="10" md="8">
        <v-text-field
          v-model="entry.scientificName"
          v-bind="getObject('scientificName')"
          label="Nome científico"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" class="" v-if="entry.newVarieties">
        <NewVarietyIndex
          :exitMovementItems="entry.newVarieties"
          :readOnly="readOnly"
          :hasTableTitle="true"
          tableTitle="Variedades ainda não cadastradas"
        />
        </v-col>
      
    </v-row>
  </v-form>
</template>

<script>
import BaseUtil from "@shared_components/base_util.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import PackagingNew from "@models/packagings/new.vue";
import gql from 'graphql-tag';
import NewVarietyIndex from './new_variety_index.vue';

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  components: {    
    BaseUtil: BaseUtil,
    MultiSelect: MultiSelect,
    PackagingNew: PackagingNew,
    NewVarietyIndex: NewVarietyIndex,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);  
    // console.log("culture", this.entry);
  },
  mounted() {
    if(this.entry.id){
      this.getPackagingsForCulture(true);    
    }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    unitCreated: function(unit) {
      this.extraData.globalContext.allUnits.unshift(unit);
      this.entry.unitId = unit.id;
      this.entry.unit = unit;
    },
    changeForage: function() {
      
    },
    packagingCreated: function(packaging) {
      // if (brand.brandType == "item") {
      this.packagingsList.unshift(packaging);
      this.entry.packagingIds.push(packaging.id);
      // this.entry.brand = brand;
      // } else {
      //   this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      // }
    },

    getPackagingsForCulture: function(hasChanged) {
      this.packagingsList = this.extraData.globalContext.allPackagings;
      this.packagingsListKey++;
      // this.packagingsListLoading = true;
      // this.$apollo
      //   .query({
      //     query: AVAILABLE_PACKAGING_FOR_CULTURE_QUERY,
      //     fetchPolicy: "no-cache",
      //     variables: {
      //       cultureId: this.entry.id
      //     }
      //   })
      //   .then(response => {
      //     // console.log("cities", response.data, this.entry);
      //     this.packagingsList = response.data.adminContext.availablePackagingsForCulture;
      //     console.log(this.packagingsList);
      //     this.packagingsListKey++;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.packagingsListLoading = false));
    },
  }
};

const AVAILABLE_PACKAGING_FOR_CULTURE_QUERY = gql `
  query ($cultureId: ID!) {
    adminContext {
      availablePackagingsForCulture(cultureId: $cultureId) {
        id
        name
      }
    }
  }
`;
</script>

<style scoped></style>
